export default __webpack_public_path__ + "images/08c5e63c08185c445ce1eb0c1ae72806-budget-friendly.webp";